import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { logger } from '../utils/logger';

const handleError = (error: Error, context?: { mutation?: boolean; query?: boolean }) => {
  // Always log errors for debugging
  logger.error(error, context);
};

const memoizeQueryClient = (getter: () => QueryClient): (() => QueryClient) => {
  let client: QueryClient | undefined;
  return () => {
    if (!client) {
      client = getter();
    }
    return client;
  };
};
const buildQueryClient = memoizeQueryClient(
  () =>
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: 3,
        },
      },
      queryCache: new QueryCache({
        onError: error => {
          if (error) {
            handleError(error, { query: true });
          }
        },
      }),
      mutationCache: new MutationCache({
        onError: error => {
          if (error) {
            handleError(error, { mutation: true });
          }
        },
      }),
    }),
);

export const queryClient = () => {
  return buildQueryClient();
};
